<template>
    <div>
      <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
      <router-view></router-view>
    </div>
</template>
<script>
import { BBreadcrumb } from 'bootstrap-vue'

export default {
  components: {
    BBreadcrumb
  },
  data () {
    return {
      breadcrumb: [
        {
          text: 'Tablero',
          to: { name: 'dashboard' }
        },
        {
          text: 'Roles',
          to: { name: 'enterprises' }
        },
        {
          text: 'Lista',
          active: true
        }
      ]
    }
  }
}
</script>
